
class ListInsight {
  constructor(element, ...options) {
    this.defaults = {
      listNavSelector: '.js-list-slider-nav',
      listSliderSelector: '.js-list-slider',
      sliderOptions: {
        mode: 'gallery',
        controls: false,
        speed: 1500,
        autoHeight: true,
      }
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.listNavElement = this.element.querySelector(this.options.listNavSelector);
    this.listSliderElements = [].slice.call(this.element.querySelectorAll(this.options.listSliderSelector));
    this.sliderObjects = [];

    this.listSliderElements.forEach((slider) => {
      this.sliderObjects.push(new TinySlider(slider, Object.assign({}, this.options.sliderOptions, {
        navContainer: this.listNavElement,
      })))
    });
  }

  bindEvents() {

  }
}
